import { Card, Typography } from "antd";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { brand } from "../app/theme.ts";

/** Centered card with the school logo, shared by the anonymous screens (login, forgot and reset password). */
export function AuthCard({ subtitle, children }: { subtitle: string; children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 16,
        boxSizing: "border-box",
        background: `radial-gradient(1200px 600px at 50% -10%, rgba(23, 63, 53, 0.08), transparent 60%), ${brand.cream}`,
      }}
    >
      <main style={{ width: "100%", maxWidth: 400 }}>
        <Card
          style={{ borderColor: brand.border, boxShadow: "0 12px 32px -12px rgba(17, 24, 20, 0.16)", overflow: "hidden" }}
          styles={{ body: { padding: "32px 28px 28px" } }}
        >
          <div aria-hidden style={{ position: "absolute", inset: "0 0 auto 0", height: 3, background: brand.green }} />
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <img src="/school-logo.jpg" alt="" width={60} height={60} style={{ borderRadius: 14, objectFit: "cover", boxShadow: `0 0 0 1px ${brand.border}` }} />
            <Typography.Title level={4} style={{ margin: "14px 0 2px" }}>
              {t("app.name")}
            </Typography.Title>
            <Typography.Text type="secondary">{subtitle}</Typography.Text>
          </div>
          {children}
        </Card>
      </main>
    </div>
  );
}
